import { Injectable } from '@angular/core';
import { Observable, Subject, filter } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { AuthData } from '../api/contracts/auth';

@Injectable({
  providedIn: 'root',
})
export class AppEventsService {
  readonly afterLogin: Subject<AuthData> = new Subject<AuthData>();
  readonly afterLogout: Subject<void> = new Subject<void>();
  readonly afterLocationChanged: Subject<void> = new Subject<void>();

  readonly afterNavigationEnd: Observable<NavigationEnd>;

  constructor(private readonly router: Router) {
    this.afterNavigationEnd = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ) as Observable<NavigationEnd>;
  }
}
